import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import { getIsMarketingContactsSku } from 'pricing-pages-lib/utils/productsUtils';
import { CONTACT, MARKETING_CONTACT_DEPRECATED, USER } from 'self-service-api/constants/UnitTypes';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { useState, useEffect } from 'react';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import AsyncContactsPriceBreakdownModal from '../../../common/pricing/AsyncContactsPriceBreakdownModal';
import { usePricingLibSelector } from '../../../../selectors/SelectorUtils';
import { quantityPackForProductVersionSelector, skuSelector } from '../../../../selectors/ProductsSelectors';
import { useAppSelector } from '../../../../reducers';

const IncludedUnitsSubtext = ({
  skuId,
  className,
  style = {},
  queryParamTerm,
  productConfigurations
}) => {
  const [priceBreakdownVisible, setPriceBreakdownVisible] = useState(false);
  useEffect(() => {
    if (priceBreakdownVisible) {
      getUsageTracker().track('clickToViewModal', {
        name: 'contact-picker-more-details-modal'
      });
    }
  }, [priceBreakdownVisible]);
  const quantityPackSkuId = useAppSelector(state => {
    if (!skuId) return null;
    const quantityPack = quantityPackForProductVersionSelector(state, {
      productVersionSkuId: skuId
    });
    return quantityPack && quantityPack.skuId;
  });
  const quantityPack = useAppSelector(state => {
    if (!quantityPackSkuId) return null;
    return skuSelector(state, {
      skuId: quantityPackSkuId
    });
  });
  const isMarketingContactsSku = usePricingLibSelector(state => {
    if (!skuId) return null;
    return getIsMarketingContactsSku(state, {
      skuId
    });
  });
  if (!quantityPack || !quantityPack.quantityUnit || !quantityPack.quantityUnit.unitType) return null;
  const {
    unitType,
    includedWithProductVersion
  } = quantityPack.quantityUnit;
  let jsxMessage = null;

  if (unitType === USER) {
    jsxMessage = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "merchCards.pricing.includes.usersStartsAt_jsx",
      elements: {
        Number: FormattedNumber
      },
      options: {
        value: includedWithProductVersion
      }
    });
  } else if (unitType === CONTACT || unitType === MARKETING_CONTACT_DEPRECATED) {
    if (isMarketingContactsSku) {
      jsxMessage = /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "merchCards.pricing.includes.contactsMCStartsAt_jsx",
        elements: {
          Number: FormattedNumber,
          Link: UILink
        },
        options: {
          value: includedWithProductVersion,
          onClick: () => setPriceBreakdownVisible(true),
          onMouseEnter: () => AsyncContactsPriceBreakdownModal.preload()
        }
      });
    } else {
      jsxMessage = /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "merchCards.pricing.includes.contactsStartsAt_jsx",
        elements: {
          Number: FormattedNumber
        },
        options: {
          value: includedWithProductVersion
        }
      });
    }
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [priceBreakdownVisible && /*#__PURE__*/_jsx(AsyncContactsPriceBreakdownModal, {
      quantityPackSkuId: quantityPackSkuId,
      marketingContactsSelected: includedWithProductVersion,
      handleModalClose: () => setPriceBreakdownVisible(false),
      productConfigurations: productConfigurations,
      queryParamTerm: queryParamTerm
    }), /*#__PURE__*/_jsx("div", {
      className: className,
      style: style,
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        className: "m-right-2",
        children: jsxMessage
      })
    })]
  });
};

export default IncludedUnitsSubtext;